var render, staticRenderFns
import script from "./VuesticTimelineItem.vue?vue&type=script&lang=js"
export * from "./VuesticTimelineItem.vue?vue&type=script&lang=js"
import style0 from "./VuesticTimelineItem.vue?vue&type=style&index=0&id=3b956e2c&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b956e2c')) {
      api.createRecord('3b956e2c', component.options)
    } else {
      api.reload('3b956e2c', component.options)
    }
    
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-timelines/VuesticTimelineItem.vue"
export default component.exports